module.exports = __webpack_public_path__ + "app/assets/images/woman16-c42b135dc36195c563bac80d720d831b.jpg";